// extracted by mini-css-extract-plugin
module.exports = {"container":"Exercise_container__KgfsB","title":"Exercise_title__1RJL6"};